import { getCountry } from '@iwIntlProvider/CountryProvider';

import { ApprovedViewDE } from './ApprovedViewDE';
import { FlexiApprovedView } from './flexiApprovedView/FlexiApprovedView';
import { FundingProgressIndicator } from '../../funding/fundingSteps/FundingProgessIndicator/FundingProgressIndicator';
import { useRestoreOfferConfigurationStep } from '../offerFlowMemory/useRestoreOfferConfigurationStep';

export const ApprovedView = () => {
    useRestoreOfferConfigurationStep();

    if (getCountry() === 'DE') {
        return <ApprovedViewDE />;
    }
    return (
        <>
            <FundingProgressIndicator step={1} />
            <FlexiApprovedView />
        </>
    );
};
